<div class="h-100 box d-flex flex-column" elementDataTest="uploadDocumentStepElement">
    <div>
        <div class="text-l font-bold border-b border-grey-v5 pb-5" translate>v3-byoc-popup-create-episode-upload-document-title</div>
    </div>

    <div class="flex-grow-1">
        <div class="pt-4">
            <div class="inner relative" #box>
                <div class="uploader">
                    <app-file-uploader type="document" [formControl]="documentControl"></app-file-uploader>
                    <app-upload-content-terms-accept [termsAcceptControl]="termsAcceptControl"></app-upload-content-terms-accept>
                </div>
            </div>
        </div>
    </div>
    <div class="theme-new d-flex align-items-center">
        <button (click)="cancel()" class="btn ms-auto btn-primary" buttonDataTest="cancelButton" translate>v3-button-cancel</button>
        <button
            *ngIf="hasFile"
            (click)="next()"
            [ngClass]="{ 'btn-disabled': !hasAcceptTerms }"
            class="btn btn-secondary continue"
            translate
            buttonDataTest="continueButton"
            [ariaDisabled]="!hasAcceptTerms"
        >
            v3-button-continue
        </button>
    </div>
</div>
